import { usePost } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useCreateChargeOffReason() {
  const post = usePost(true, "tms");
  const createChargeOffReason = (request: any) =>
    post<{ id: string }>(`${referenceDataBaseUrl}/charge-off-reasons`, request);

  return useMutationWithErrorHandling({
    mutationFn: async (request: any) => await createChargeOffReason(request),
  });
}
